var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_59588)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.52 12.2713C23.5189 11.4484 23.4453 10.6272 23.3 9.81729H12V14.4593H18.458C18.3244 15.1936 18.0433 15.8931 17.6316 16.5157C17.22 17.1382 16.6863 17.6708 16.063 18.0813V21.0923H19.941C21.1221 19.9549 22.051 18.582 22.6674 17.0626C23.2838 15.5431 23.5739 13.9111 23.519 12.2723L23.52 12.2713Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.9983C14.9211 24.0773 17.7621 23.0374 19.942 21.0913L16.064 18.0803C15.1363 18.6757 14.0849 19.0514 12.99 19.1788C11.8951 19.3062 10.7855 19.1819 9.74595 18.8154C8.70636 18.4488 7.76419 17.8498 6.99127 17.0638C6.21836 16.2779 5.63511 15.3259 5.286 14.2803H1.276V17.3893C2.27533 19.3766 3.80737 21.047 5.70106 22.2141C7.59476 23.3811 9.77557 23.9989 12 23.9983Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28499 14.2783C4.7836 12.7996 4.7836 11.197 5.28499 9.7183V6.6093H1.27599C0.437085 8.28185 0.000244141 10.1272 0.000244141 11.9983C0.000244141 13.8694 0.437085 15.7147 1.27599 17.3873L5.28499 14.2783Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.77129C13.7057 4.74252 15.3539 5.3875 16.587 6.56629L20.029 3.12329C17.857 1.08326 14.9796 -0.0366787 12 -0.00170741C9.77536 -0.00210069 7.5944 0.615919 5.70069 1.78333C3.80697 2.95075 2.27505 4.6216 1.276 6.60929L5.285 9.71829C5.74591 8.29478 6.64179 7.05173 7.84645 6.16424C9.05111 5.27676 10.5038 4.78957 12 4.77129Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_59588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.005,
    fill: "white",
    transform: "translate(0 -0.00250244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4b4420c2.svg";
export { ForwardRef as ReactComponent };